import { connect } from 'react-redux';
import Extension from '../../components/handoff/Extension';
import { getZoomScale, getPixelRatio } from '../../selectors/handoff';
function mapStateToProps(state) {
    return {
        zoomScale: getZoomScale(state),
        pixelRatio: getPixelRatio(state),
    };
}
export default connect(mapStateToProps, null)(Extension);
